<!-- Zweck: Stellt die HTML-Struktur für shop view filter component im Frontend bereit. -->
<div class="shop-view-filter">
  @for (f of view.filters; track f) {
    <shop-view-filter-menu (change)="doChange()" [filter]="f"
    [filtercomp]="this"></shop-view-filter-menu>
  }
</div>
